import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "@/components/landing/Shared";

const FAQS = [
  { q: "Is this for beginners?", a: "100%. We've got Zooms, training, and support for day-one starters." },
  { q: "Do I need to show my face?", a: "Nope. You can be fully faceless if you want to." },
  { q: "What if I've tried courses before and they didn't work?", a: "That's exactly why I came here. I've done those too. This isn't a get rich scheme. It's a get unstuck solution." },
  { q: "Is there coaching?", a: "Yep! Weekly Zooms, mindset calls, tech calls, and more." },
];

export const Faq = () => (
  <section className="bg-[var(--cream)] px-5 py-24 sm:px-8 lg:py-32" data-testid="section-faq">
    <div className="mx-auto max-w-3xl">
      <Reveal className="text-center">
        <h2 className="font-display text-4xl font-light tracking-tight sm:text-5xl" data-testid="faq-heading">Frequently Asked Questions</h2>
      </Reveal>
      <Accordion type="single" collapsible className="mt-12 space-y-3">
        {FAQS.map((f, i) => (
          <AccordionItem key={f.q} value={`q${i}`} className="rounded-2xl border border-[var(--blush-deep)] bg-white px-6">
            <AccordionTrigger className="font-display py-5 text-left text-lg hover:no-underline sm:text-xl" data-testid={`faq-question-${i + 1}`}>{f.q}</AccordionTrigger>
            <AccordionContent className="pb-5 text-base text-[var(--muted)]" data-testid={`faq-answer-${i + 1}`}>{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
